import axios from "axios";
import { get, post} from "../../utils/BaseService";
import { CreateTemplateDto } from "@/types/temp.types";

export async function getAllTemplates(dispatch: any,input:any) {
  return await post(dispatch, '/templates/getAll', input);
}

export async function getTemplateById(dispatch: any, id: string) {
  return await get(dispatch, `/templates/getTemplateById/${id}`, null);
}

export async function updateTemplateSettings(dispatch: any, id: string, settings: any) {
  const response = await axios.put(
    `/templates/${id}/settings`,
    settings,
    {
      headers: {
        'Content-Type': 'application/json',
        // Add auth header if needed:
        // 'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response
}

export async function uploadTemplateLogo(dispatch: any, id: string, logoFile: File) {
  const formData = new FormData();
  formData.append('logo', logoFile);
  return await post(dispatch, `/templates/${id}/logo`, formData);
}

export async function setDefaultTemplate(dispatch: any, id: string) {
  return await post(dispatch, `/templates/${id}/default`, {});
}

export async function createTemplate(dispatch:any,input:CreateTemplateDto){
  return post(dispatch,"/templates/createTemplate",input)
}

export async function updateTemplate(dispatch:any,id:number,input:CreateTemplateDto){
  return post(dispatch,`/templates/updateTemplate/${id}`,input)
}